(ns frontend.view.profile.db
  (:require [frontend.db :as db]
            [reagent.core :as r]))

(defonce state (r/cursor db/app-state [:views :personal-profile]))
(defonce account (r/cursor db/app-state [:session :account]))
(defonce mfa (r/cursor state [:mfa]))
